import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { CompartmentEndpoint } from '../constants/compartment-endpoint';
import { CompartmentBrief, CompartmentListURIParams } from '../models';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { HubEndpoint } from '../../hub/constants/hub-endpoint';

@Injectable({
  providedIn: 'root',
})
export class CompartmentListService {
  constructor(private http: WrapperHttpService) {}

  getCompartmentList({ hubId, searchCriteria }: CompartmentListURIParams): Observable<CompartmentBrief[]> {
    const url =
      `${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}?` + getQueryStringFromObject(searchCriteria);
    return this.http.withLoading().get<CompartmentBrief[]>(url);
  }
}
